import { Box } from '@mui/material'
import React from 'react'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import PersonIcon from '@mui/icons-material/Person';
import { set } from 'lodash';
import Person3Icon from '@mui/icons-material/Person3';
import Person4Icon from '@mui/icons-material/Person4';
import { IGetCustomerInfoResponse } from '../../../models/customer.model';


interface IProfileCard extends IGetCustomerInfoResponse {
    setState: (state: 'profile' | 'support' | 'userProfile') => void
}


const ProfileCard = ({ fullName, mobileNumber, nationalCode, birthDatePersian, genderType, setState, goftinoUserId }: IProfileCard) => {
    return (
        <Box sx={{ border: "1px solid var(--border-color)", borderRadius: "10px", background: "var(--input-bg-color)", marginInline: "20px", padding: "20px", boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.16)' }}>
            {/* <MoreHorizIcon sx={{ color: "var(--tirnary-text-color)", marginTop: "-20px" }} onClick={() => setState('userProfile')} /> */}
            <div className='flex items-center w-full'>
                <div className='bg-[var(--input-bg-color)] shadow-md rounded-[1rem] p-2 mx-auto mt-[-85px]'>
                    {genderType === 'Female' ? <Person3Icon sx={{ fontSize: "70px", color: "#BBA57A" }} /> : <Person4Icon sx={{ fontSize: "70px", color: "#BBA57A" }} />}

                </div>
            </div>
            {fullName && <div className='text-center my-6 font-bold text-[1.1rem] text-[var(--primary-text-color)]'>{fullName}</div>}
            <div className='flex w-full justify-center text-[var(--primary-text-color)]'>
                <div className='flex flex-col gap-2 w-full text-center'>
                    <div className='text-[var(--tirnary-text-color)] text-[.8rem]'>شماره همراه</div>
                    <div className='text-[.9rem]'>{mobileNumber}</div>
                </div>
                <div className={`flex flex-col gap-2 w-full ${birthDatePersian ? 'border-x border-x-[#D7DBEC]' : 'border-r border-r-[#D7DBEC]'}  text-center`}>
                    <div className='text-[var(--tirnary-text-color)] text-[.8rem]'>کد ملی</div>
                    <div className='text-[.9rem]'>{nationalCode}</div>
                </div>
                {birthDatePersian && <div className='flex flex-col gap-2 w-full text-center'>
                    <div className='text-[var(--tirnary-text-color)] text-[.8rem]'>تاریخ تولد</div>
                    <div className='text-[.9rem]'>{birthDatePersian}</div>
                </div>}
            </div>
        </Box>
    )
}

export default ProfileCard